<table class="custom-table-list" aria-label="users">
  <thead class="custom-table-list-headings">
    <th class="custom-col-width-10">Status</th>
    <th class="custom-col-width-15 ps-4">Name</th>
    <th class="custom-col-width-15">Email ID</th>
    <th class="custom-col-width-15 ps-4">Mobile No</th>
    @if (!isAdmin) {
      <th class="custom-col-width-20 ps-3">Branches</th>
    }
    <th class="custom-col-width-15">Roles</th>
    @if (!isAdmin && selfDetails?.primary && envType == appType.dams) {
      <th appAccessControl allowedModules="documentVault.scanner"
      class="custom-col-width-10">Licence Key</th>
    }
    <th class="custom-col-width-10" appAccessControl allowedModules="workFlow.enabled">Departments</th>
  </thead>

  @for (tableData of userData; track tableData) {
    <tr class="custom-table-list-row-main cursor-pointer">
      <td class="custom-col-width-10 userTable__status clickable-td" (click)="editUser('status', tableData)">
        @if (tableData.status === 'New') {
          <div>
            <img src="../../../../assets/Images/user-management/user-invited.svg" alt="invited" />
          </div>
        }
        @if (tableData.status === 'Locked') {
          <div>
            <img src="../../../../assets/Images/user-management/user-unverified.svg" alt="unverified" />
          </div>
        }
        @if (tableData.status === 'Active') {
          <div>
            <img src="../../../../assets/Images/user-management/user-verified.svg" alt="verified" />
          </div>
        }
        @if (tableData.status === 'Inactive') {
          <div>
            <img src="../../../../assets/Images/user-management/user-unverified.svg" alt="inactive" class="inactive-icon" />
          </div>
        }
      <div [ngClass]="{
        userTable__statusTextBlue: tableData.status === 'New',
        userTable__statusTextOrange: tableData.status === 'Locked',
        userTable__statusTextGreen: tableData.status === 'Active',
        userTable__statusTextRed: tableData.status === 'Inactive'
      }">
          {{ tableData.status }}
        </div>
        @if (tableData.primary) {
          <p class="badge badge-primary badge-lt-40">
            Primary
          </p>
        }
      </td>
      <td class="custom-col-width-15 clickable-td ps-4" (click)="editUser('name', tableData)">
        <span class="documentRowCards__container--text" [ngbTooltip]="getTooltipName(tableData?.name)"
          [placement]="'top-start'" [tooltipClass]="'custom-tooltip'">
          {{tableData?.name}}
        </span>
      </td>
      <td class="custom-col-width-15 clickable-td" (click)="editUser('email', tableData)">
        <span class="documentRowCards__container--text" [ngbTooltip]="getTooltipEamilName(tableData?.emailAddress)"
          [placement]="'top-start'" [tooltipClass]="'custom-tooltip'">
          {{tableData?.emailAddress}}
        </span>
      </td>
      <td class="custom-col-width-15 ps-4 clickable-td" (click)="editUser('mobileNumber', tableData)">
        @if (tableData?.mobileNumber?.length < maxFilelength) {
          <span class="documentRowCards__container--text" [ngbTooltip]="tableData?.mobileNumber" [placement]="'top-start'" [tooltipClass]="'custom-tooltip'">
          {{ tableData?.mobileNumber }}</span>
        }
        @if (tableData?.mobileNumber?.length >= maxFilelength) {
          <span class="documentRowCards__container--text" [ngbTooltip]="tableData?.mobileNumber" [placement]="'top-start'" [tooltipClass]="'custom-tooltip'">
            {{largeFileName(tableData?.mobileNumber)}}...
          </span>
        }
      </td>
      @if (!isAdmin) {
        <td class="custom-col-width-20 ps-3 clickable-td">
          <span (click)="!tableData?.company?addBranch(tableData): editUser('company', tableData)" class="documentRowCards__container--text" (mouseover)="openPanel('Company',tableData, $event)"
            (mouseout)="closePanael('Company')">
            {{ tableData?.company }}
          </span>
          <p-popover #Company>
            <ng-template pTemplate="content">
              <div class="roles_background">
                <ul>
                  @for (company of companyData; track company; let i = $index) {
                    <li>
                      <div class="role_text">{{ company }}</div>
                      @if (i != companyData.length - 1) {
                        <hr class="hr_spacing">
                      }
                    </li>
                  }
                </ul>
              </div>
            </ng-template>
          </p-popover>
          <div appAccessControl allRoles="company.view,user.edit">
            @if (!tableData?.company) {
              <a (click)="addBranch(tableData)">Add Branch</a>
            }
          </div>
        </td>
      }
      <td class="custom-col-width-15 clickable-td">
        <span (click)="!tableData?.roles?addBranch(tableData):editUser('roles', tableData)" class="documentRowCards__container--text" (mouseover)="openPanel('Branch',tableData, $event)"
          (mouseout)="closePanael('Branch')">
        {{(tableData?.primary && tableData?.enrollmentType === 'Admin') ? 'Super Admin' :  tableData?.roles }}</span>
        <p-popover #Branch>
          <ng-template pTemplate="content">
            <div class="roles_background">
              <ul>
                @for (role of userRoleData; track role; let i = $index) {
                  <li>
                    <div class="role_text">{{ role }}</div>
                    @if (i != userRoleData.length - 1) {
                      <hr class="hr_spacing">
                    }
                  </li>
                }
              </ul>
            </div>
          </ng-template>
        </p-popover>
        @if (!tableData?.roles && !isAdmin) {
          <a appAccessControl allRoles="user.edit,role.view" (click)="addBranch(tableData)">Add Role</a>
        }
      </td>
      @if (!isAdmin && selfDetails?.primary && envType == appType.dams) {
        <td appAccessControl
          allowedModules="documentVault.scanner" class="custom-col-width-5">
          <div class="text-secondary text-center">
            @if (userLicences.indexOf(tableData._id) === -1) {
              <div class="icon-key">
                <app-common-icon class="key-color" placement="top" toolTip="Assign scanner licence key"
                (clickEvent)="assignScanLicence(tableData)" [faIcon]="faKey"></app-common-icon>
                @if (tableData?.licenseId) {
                  <fa-icon class="check-icon" [icon]="faCircleCheck"></fa-icon>
                }
              </div>
            }
            @if (userLicences.indexOf(tableData._id) !== -1) {
              <div class="icon-key">
                <fa-icon class="check-icon" [icon]="faCircleCheck"></fa-icon>
              </div>
            }
          </div>
        </td>
      }
      <td appAccessControl allowedModules="workFlow.enabled" class="custom-col-width-5 clickable-td" (click)="editUser('name', tableData)">
        <span class="documentRowCards__container--text" [ngbTooltip]="getDepartmentTooltip(tableData?.departments?.[0]?.name)"
          [placement]="'top-start'" [tooltipClass]="'custom-tooltip'">
          {{tableData?.departments?.[0]?.name || "-"}}
        </span>
      </td>
      <td class="custom-col-width-5 clickable-td">
        @if (selfDetails?.primary) {
          <div class="icon-key text-secondary text-center" (click)="editUser('updatePassword', tableData)">
            <img src="assets/Images/user-management/password-reset.svg" class="password-reset-icon" alt="Update Password" ngbTooltip="Update Password" placement="top">
          </div>
        }
        <p-popover #op>
          <ng-template pTemplate="content">
          </ng-template>
        </p-popover>
      </td>
    </tr>
  }
  @if (userData?.length === 0) {
    <div class="text-danger d-flex justify-content-center">
      <h4>No records found</h4>
    </div>
  }

</table>


<ng-template tabindex="-1" #selecteLicence aria-labelledby="selecteLicence" aria-hidden="true"
  let-selecteLicence>
  <div class="modal-header zindex-modal">
    <h4 class="modal-title" id="modal-basic-title">
      Assign Scanner Licence
    </h4>
    <div (click)="selecteLicence.dismiss(false)"  class="close">
      <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon">
    </div>
  </div>
  <div class="modal-body">
    <div class="row mt-2">
      <div class="col">
        <div class="form-group">
          <div class="dropdown">
            <div class="dropdownLabel">Licence</div>
            <select #licence (change)="onChangeLicence(licence.value)" class="dropdownOptions drop-down">
              <option value="" disabled selected>Select Licences</option>
              @for (item of companyLicences; track item) {
                <option [value]="item._id">
                  {{ item.value.substring(0, 45) }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="text-right">
      <div class="d-flex justify-content-end">
        <app-common-button class="m-1" buttonClass="smallbutton" buttonLabel="Cancel"
        (clickEvent)="selecteLicence.dismiss(false)"></app-common-button>
        <app-common-button [loadingIcon]="loderIcon" [disabled]="!selectedLicence" (clickEvent)="selecteLicence.close(true)"
        class="m-1" buttonClass="smallFilledButton" buttonLabel="Submit"></app-common-button>
      </div>
    </div>
  </div>
</ng-template>

@if (isToaster) {
  <app-toast [title]="message" (closeToaster)="closeToaster($event)"></app-toast>
}

@if (isErrorToaster) {
  <app-error-toaster [title]="message" (closeToaster)="closeToaster($event)"></app-error-toaster>
}
